import { render, staticRenderFns } from "./ResearchPreferencesForm.vue?vue&type=template&id=425b3ee9&"
import script from "./ResearchPreferencesForm.vue?vue&type=script&lang=js&"
export * from "./ResearchPreferencesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports